import AddLeadModal from './AddLeadModal.component';

export default AddLeadModal;